import * as React from 'react';
import { Link } from 'react-router-dom';
import { LProps, withLocalization } from '../utils/wrappers';
import { makeCatalogBreakdownPath } from '../utils/routerHelper';

const PledgesCatalogBreakdownLink = ({ t }: LProps<{}>) => (
  <Link to={makeCatalogBreakdownPath()}>{t('Catalog points breakdown')}</Link>
);

export default withLocalization('pledges')(PledgesCatalogBreakdownLink) as React.SFC<{}>;
